window.bootstrap = require('bootstrap');
window.toastr = require('toastr');
